/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1SerieSerieidLangsIdMutationRequest,
  PutApiV1SerieSerieidLangsIdMutationResponse,
  PutApiV1SerieSerieidLangsIdPathParams,
  PutApiV1SerieSerieidLangsId400,
  PutApiV1SerieSerieidLangsId401,
  PutApiV1SerieSerieidLangsId404,
  PutApiV1SerieSerieidLangsId500,
} from "../../types/serieIdiomasController/PutApiV1SerieSerieidLangsId.ts";

function getPutApiV1SerieSerieidLangsIdUrl(
  serieId: PutApiV1SerieSerieidLangsIdPathParams["serieId"],
  id: PutApiV1SerieSerieidLangsIdPathParams["id"],
) {
  const res = {
    method: "PUT",
    url: `/api/v1/serie/${serieId}/langs/${id}` as const,
  };
  return res;
}

/**
 * @description Atualiza os textos de uma tradução (idioma) da série. **(Requer Authorization para autenticação)**
 * @summary Atualizar idioma da série (Requer Authorization para autenticação)
 * {@link /api/v1/serie/:serieId/langs/:id}
 */
export async function putApiV1SerieSerieidLangsId(
  serieId: PutApiV1SerieSerieidLangsIdPathParams["serieId"],
  id: PutApiV1SerieSerieidLangsIdPathParams["id"],
  data?: PutApiV1SerieSerieidLangsIdMutationRequest,
  config: Partial<RequestConfig<PutApiV1SerieSerieidLangsIdMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1SerieSerieidLangsIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1SerieSerieidLangsId400
      | PutApiV1SerieSerieidLangsId401
      | PutApiV1SerieSerieidLangsId404
      | PutApiV1SerieSerieidLangsId500
    >,
    PutApiV1SerieSerieidLangsIdMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1SerieSerieidLangsIdUrl(serieId, id).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
